import { Component, Input } from '@angular/core';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';
import { CardInfos } from '../../models/card-infos.model';
import { DateInterval } from '../../models/date-interval.model';

import { FadingSpanComponent } from '../fading-span/fading-span.component';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular/lazy';

@Component({
    selector: 'web-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    imports: [FadingSpanComponent, TranslateModule, IonicModule],
})
export class CardComponent extends AbstractComponentMobile {
    public override tag = '[CardComponent]';

    @Input()
    public cardInfo?: CardInfos;

    @Input()
    public dateInterval?: DateInterval;
}
